import React from 'react';
import {useState, useEffect} from "react";
import {useParams, Link, useNavigate} from 'react-router-dom';
import Moment from 'moment';
import {
	getEvents, 
	formatDate, 
	formatDuration, 
	parseDateISOString, 
	incrementDate, 
	isToday,
	getDateCaption
} from "./apiService";

let renderCount = 0;
let intervalId = null;

const Events = (props) => {
	const [error, setError] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [events, setEvents] = useState([]);
	const [date, setDate] = useState(null);
	const {dateParam} = useParams();
	const navigate = useNavigate();

	console.log('calling useEffect');
	useEffect(() => {
		console.log('Events useEffect', dateParam);
		let dateProp = dateParam;
		if(dateProp == null) {
			dateProp = formatDate(new Date());
			console.log('default date', dateProp);
		}
		setDate(parseDateISOString(dateProp));
		getEvents(dateProp).then(
			data => {
				console.log('Events.useEffect getEvents data', data);
				if(data.status === 401) {
					navigate('/login', {replace: true});
					return;
				}
				if(data.status !== 200) {
					setIsLoaded(true);
					setError(data);
					return;
				}
				setIsLoaded(true);
				setEvents(data.result);
			},
			error => {
				console.log('error object', error);
				setIsLoaded(true);
				setError(error);
			}
		);
	}, [dateParam, navigate]);

	console.log('Events render', events);

	if(error) {
		return <div>Error: {error.message}</div>;
	}

	if(!isLoaded) {
		return <div>Loading...</div>;
	}

	let prevDate = incrementDate(date, -1);
	let nextDate = incrementDate(date, 1);
	let lastEvent = events[events.length - 1];
	console.log('lastEvent', lastEvent);
	Moment.locale('en');
	renderCount++;
	console.log('renderCount', renderCount);
	if(intervalId) {
		window.clearInterval(intervalId);
	}
	intervalId = window.setInterval(() => {
		if(lastEvent) {
			let td = document.querySelector(`#row-${lastEvent.id} td.duration`);
			if(td) {
				let moment = Moment(lastEvent.time);
				let d = moment.toDate();
				let ms = d.getTime();
				td.textContent = formatDuration(new Date().getTime() - ms);
			}
		}
	}, 1000);
	let html = (
		<>
		<div className="header">
			<div className="header-date">Events on {formatDate(date)}</div>
			<div className="header-links">
				<Link to={`/events/${formatDate(prevDate)}`}>{getDateCaption(prevDate)}</Link> &nbsp;
				<Link to={`/events/${formatDate(nextDate)}`}>{getDateCaption(nextDate)}</Link> &nbsp;
				{
					!isToday(date) && !isToday(prevDate) && !isToday(nextDate) 
						? <> <Link to={`/events/${formatDate(new Date())}`}>Today</Link> &nbsp; </>
						: ''
				}
				<Link to={`/edit`}>Add</Link>
			</div>
		</div>
		<table className="events">
		<thead>
			<tr>
				<th>Time</th>
				<th>Projects</th>
				<th>Duration</th>
			</tr>
		</thead>
		<tbody>
		{
			events.map(event => {
				Moment.locale('en');
				console.log('event', event);
				return (
					<tr key={event.id} id={`row-${event.id}`}>
						<td>{Moment(event.time).format('HH:mm:ss')}</td>
						<td>
						{
							event.projects.map((levelProjects, index) => {
								console.log('levelProjects', levelProjects);
								return (
									<div key={index}>
									{
										levelProjects.map(project => {
											return <span key={project.id}><Link to={`/projects/${project.id}`}>{project.code}</Link> &nbsp;</span>;
										})
									}
									</div>
									)
							})
						}
						</td>
						<td className="duration">{formatDuration(event.duration)}</td>
						<td>
							<Link to={`/delete/${event.id}`}>Delete</Link> &nbsp;
							<Link to={`/duplicate/${event.id}`}>Duplicate</Link> &nbsp;
							<Link to={`/edit/${event.id}`}>Edit</Link>
						</td>
					</tr>
				);
			})
		}
		</tbody>
		</table>
		<table className="compact">
		<tbody>
		{
			report(events)
		}
		</tbody>
		</table>
		</>
	);
	console.log('html', html);
	return html;
};

const report = events => {
	console.log('events', events);
	let rootProject = {children: []};
	for(let event of events) {
		let altProjectCount = event.projects.length;
		for(let projects of event.projects) {
			let altDuration = event.duration / altProjectCount;
			let storeProject = (level, parentProject) => {
				if(level >= projects.length) {
					// done;
					return;
				}
				let project = projects[level];
				let childProject = parentProject.children[project.code];
				if(childProject == null) {
					childProject = {
						id: project.id, 
						code: project.code, 
						duration: 0, 
						children: {}
					};
					parentProject.children[project.code] = childProject;
				}
				childProject.duration += altDuration;
				storeProject(level + 1, childProject);
			}
			storeProject(0, rootProject);
		}
	}
	let renderProject = (level, project, output) => {
		if(project.code) {
			output.push(<tr key={project.id}>
				<td style={{paddingLeft: (level * 25) + 'px'}}>{project.code}</td>
				<td>{formatDuration(project.duration)}</td>
				</tr>);
		}
		for(let code in project.children) {
			let child = project.children[code];
			renderProject(level + 1, child, output);
		}
	}
	let output = [];
	renderProject(0, rootProject, output);
	return output;
};

export default Events;